import * as React from 'react';
import { Row } from 'react-bootstrap';
import type { WrappedFieldArrayProps } from 'redux-form';
import { Field } from 'redux-form';

import type { SubjobVM } from 'ab-viewModels/workRequest/jobUpsert.viewModel';

import { Button } from '@acceligentllc/storybook';

import type { TimeAllocationEntryFormModel } from '../formModel';
import TimeAllocationEntry from './TimeAllocationEntry';
import styles from '../styles.module.scss';
import { TimeAllocationEntryAction } from '../TimeSheetEditModalBody';

export interface OwnProps {
	readonly: boolean;
	index: number;
	isAllowedToAddTimeAllocations: boolean;
	subJobs: SubjobVM[];
	change: (fieldName: string, value) => void;
	changeEntries: (action: TimeAllocationEntryAction, entryIndex: Nullable<number>) => void;
	shouldRoundTimeIntervalsTo1Min: boolean;
}

type Props = OwnProps & WrappedFieldArrayProps<TimeAllocationEntryFormModel>;

const TimeAllocationEntriesList: React.FC<Props> = (props) => {

	const {
		fields,
		change,
		readonly,
		isAllowedToAddTimeAllocations,
		subJobs,
		changeEntries,
		shouldRoundTimeIntervalsTo1Min,
	} = props;

	const removeEntry = React.useCallback((index: number) => {
		changeEntries(TimeAllocationEntryAction.REMOVE, index);
	}, [changeEntries]);

	const addEntry = React.useCallback(() => {
		changeEntries(TimeAllocationEntryAction.ADD, null);
	}, [changeEntries]);

	const renderTimeAllocationEntry = React.useCallback((field: string, index: number) => {

		const entry = fields.get(index);
		return (
			<Field
				change={change}
				changeEntries={changeEntries}
				component={TimeAllocationEntry}
				entry={entry}
				index={index}
				key={index}
				name={field}
				readonly={readonly}
				removeEntry={removeEntry}
				shouldRoundTimeIntervalsTo1Min={shouldRoundTimeIntervalsTo1Min}
				subJobs={subJobs}
			/>
		);
	}, [
		change,
		changeEntries,
		removeEntry,
		readonly,
		subJobs,
		fields,
		shouldRoundTimeIntervalsTo1Min,
	]);

	return (
		<>
			<div className={styles['time-allocations__time-allocation-list']}>
				{fields.map(renderTimeAllocationEntry)}
			</div>
			{isAllowedToAddTimeAllocations &&
				<Row className={styles['time-allocations__add-allocation']}>
					<Button
						icon="ActionPlusSmall"
						label="Add Time Allocation"
						onClick={addEntry}
						style="link"
					/>
				</Row>
			}
		</>
	);
};

export default React.memo(TimeAllocationEntriesList);
